import { useState, useRef } from "react"
import { DEFAULT_MAP_VIEW } from "../utils/mapConfig"

export const useMapController = (regions = []) => {
  const [selectedRegion, setSelectedRegion] = useState(null)
  const [position, setPosition] = useState({ ...DEFAULT_MAP_VIEW })

  const safeRegions = Array.isArray(regions) ? regions : [];

  const animationRef = useRef(null)

  const animateTo = (target) => {
    if (animationRef.current) cancelAnimationFrame(animationRef.current)

    const duration = 500
    const start = performance.now()
    const initial = { ...position }

    const step = (time) => {
      const progress = Math.min((time - start) / duration, 1)
      const ease = 1 - Math.pow(1 - progress, 3) // easeOutCubic

      const newPosition = {
        coordinates: [
          initial.coordinates[0] +
            (target.coordinates[0] - initial.coordinates[0]) * ease,
          initial.coordinates[1] +
            (target.coordinates[1] - initial.coordinates[1]) * ease,
        ],
        zoom: initial.zoom + (target.zoom - initial.zoom) * ease,
      }

      setPosition(newPosition)
      if (progress < 1) requestAnimationFrame(step)
    }

    requestAnimationFrame(step)
  }

  const selectRegion = (code) => {
    const config = safeRegions.find(r => r.code === code);
    if (!config) return;
    
    console.log(config.center_lng);

    setSelectedRegion(code);

    animateTo({
      coordinates: [
        Number(config.center_lng),
        Number(config.center_lat),
      ],
      zoom: Number(config.zoom),
    });
  };

  const resetView = () => {
    setSelectedRegion(null);
    animateTo({ ...DEFAULT_MAP_VIEW });
  };

  // ----------------------------------------------------------
  // auto-select region when user pans/zooms
  // ----------------------------------------------------------
  const handleMoveEnd = (pos) => {
    setPosition(pos);

    // if fully zoomed out, reset selection
    if (pos.zoom <= DEFAULT_MAP_VIEW.zoom) {
      setSelectedRegion(null);
      return;
    }

    if (pos.zoom < 2) return;

    // find region under current center
    const [lng, lat] = pos.coordinates;

    let closest = null;
    let minDist = Infinity;

    for (const r of safeRegions) {
      const dx = lng - Number(r.center_lng);
      const dy = lat - Number(r.center_lat);
      const dist = dx * dx + dy * dy;

      if (dist < minDist) {
        minDist = dist;
        closest = r;
      }
    }

    if (closest && closest.code !== selectedRegion) {
      setSelectedRegion(closest.code);
    }
  };

  return {
    position,
    setPosition,
    selectedRegion,
    selectRegion,
    resetView,
    handleMoveEnd,
  }
}
